import { z } from 'zod';
import { SearchSchema } from '@anytag/shared-validations';
import { InstagramFeedPostSortField } from '@anytag/graphql';

export const InfluencerInstagramPostsListSearchSchema = SearchSchema.create({
  sort: { field: InstagramFeedPostSortField },
  filter: {
    schema: z.object({
      name: SearchSchema.types.string(),
      keyword: SearchSchema.types.string()
    })
  }
});

export type InfluencerInstagramPostsListSearchType = z.infer<typeof InfluencerInstagramPostsListSearchSchema>;
